// eslint-disable-next-line import/no-anonymous-default-export, import/no-default-export
export default '4.3.0/2024-11-11T19:53';
